"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

import { APP_ROUTES } from "~/constants/appRoutes";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { getStorageItem, setStorageItem } from "~/lib/storage/Storage";
import { STORAGE_KEYS } from "~/types/Storage";
import { waitForKlaviyo } from "~/lib/klaviyo/utils";

const PATHNAMES_WITH_PRODUCT: Record<string, string> = {
    [APP_ROUTES.TREATMENT_HRT]: "oestra",
    [APP_ROUTES.TREATMENT_HRT_3]: "oestra",
    [APP_ROUTES.TREATMENT_PERIMENOPAUSE]: "oestra",
    [APP_ROUTES.TREATMENT_PERIMENOPAUSE_AD]: "oestra",
    [APP_ROUTES.TREATMENT_MENOPAUSE]: "oestra",
    [APP_ROUTES.TREATMENT_ENDOMETRIOSIS]: "oestra",
    [APP_ROUTES.TREATMENT_PCOS]: "oestra",
    [APP_ROUTES.TREATMENT_POSTPARTUM]: "oestra",
    "/treatment/testosterone": "oestra",
    [APP_ROUTES.PQP_ENDOMETRIOSIS]: "oestra",
    [APP_ROUTES.PQP_POSTPARTUM]: "oestra",
    [APP_ROUTES.PQP_OESTRA]: "oestra",
    [APP_ROUTES.PQP_OESTRA_MENOPAUSE]: "oestra",
    [QUIZ_ROUTES.HORMONE_IMBALANCE]: "oestra",
    [QUIZ_ROUTES.POSTPARTUM]: "oestra",
    [QUIZ_ROUTES.ENDOMETRIOSIS]: "oestra",
    [QUIZ_ROUTES.OESTRA_CHECK_IN]: "oestra",
    [APP_ROUTES.OESTRA_REASONS]: "oestra",
    [APP_ROUTES.PERI_LABS]: "oestra",
    [APP_ROUTES.MENOPAUSE_WEIGHT_GAIN]: "oestra",
    [APP_ROUTES.MENOPAUSE_AD]: "oestra",
    [APP_ROUTES.COMPARE_MIDI_HEALTH]: "oestra",
    [APP_ROUTES.COMPARE_HONE_HEALTH]: "oestra",
    [APP_ROUTES.COMPARE_ALLOY_HEALTH]: "oestra",
    [APP_ROUTES.COMPARE_WINONA_HEALTH]: "oestra",
    "/product-page": "oestra",

    [QUIZ_ROUTES.ANTI_AGING_FACE_CREAM]: "bodymatched",
    [APP_ROUTES.PQP_ANTI_AGING_FACE_CREAM]: "bodymatched",
    [APP_ROUTES.BODYMATCHED_7_REASONS]: "bodymatched",
    [APP_ROUTES.BODYMATCHED_ESTRIOL]: "bodymatched",
    [APP_ROUTES.BODYMATCHED_TRETINOIN]: "bodymatched",
    [APP_ROUTES.BODYMATCHED_PERIMENOPAUSE_SKIN]: "bodymatched",
    [APP_ROUTES.FINASTERIDE]: "bodymatched",
    [APP_ROUTES.NIACINAMIDE]: "bodymatched",

    [QUIZ_ROUTES.NAD]: "nad+",
    "/p/longevity/nad": "nad+",
    [APP_ROUTES.PQP_NAD]: "nad+",

    [APP_ROUTES.PQP_LIBIDA]: "libida",
    [QUIZ_ROUTES.LIBIDA]: "libida",
    [APP_ROUTES.LIBIDA_LP]: "libida",
    [APP_ROUTES.LIBIDA_LP_PT141]: "libida",
    [APP_ROUTES.LIBIDA_LP_SCREAM]: "libida",
    [APP_ROUTES.LIBIDA_7_REASONS]: "libida",
    [APP_ROUTES.LIBIDA_AD]: "libida",
    [APP_ROUTES.TREATMENT_HRT_LIBIDO]: "libida",
};

export const KlaviyoTracker = () => {
    const pathname = usePathname();
    const [isVisitTracked, setVisitTracked] = useState(false);

    useEffect(() => {
        if ( pathname.startsWith("/p/learn/") ) return;

        const savedProduct = getStorageItem(STORAGE_KEYS.INTERESTED_PRODUCT);
        if (savedProduct) return;

        const product = PATHNAMES_WITH_PRODUCT[pathname];
        if (!product) return;

        setStorageItem(STORAGE_KEYS.INTERESTED_PRODUCT, product);
    }, [pathname]);

    useEffect(() => {
        if (isVisitTracked) return;

        const product = PATHNAMES_WITH_PRODUCT[pathname];
        if (!product) return;

        const fireEvent = () => {
            if (typeof window.klaviyo?.track !== "function") return;

            window.klaviyo.track("User - Visit Product", {
                url: window.location.href,
                path: pathname,
                product: product,
            });
        };

        if (typeof window.klaviyo?.track === "function") {
            fireEvent();
        } else {
            waitForKlaviyo().then(fireEvent);
        }

        setVisitTracked(true);
    }, [pathname, isVisitTracked]);

    return null;
};

export default KlaviyoTracker;